import { BoosterService } from '@/services/booster.service'
import { BoosterImporterService } from '@/services/booster-importer.service'
import { UserService } from '@/services/user.service'
import { HTTP_STATUS_CODES } from '@/configs/constants.ts'
import { commitPaginationFromMeta, isOk, showErrorToast } from './helpers'

export const boosterActions = {
  async loadUserBoostersSelect({ commit }, userId) {
    const response = await BoosterService.fetchUserBoosterSelect(userId)
    commit('SET_USER_BOOSTER_SELECT', response.data)
  },

  async createBooster(_, data) {
    const response = await BoosterService.createBooster(data)
    if (response.status === HTTP_STATUS_CODES.OK) {
      return true
    } else {
      return response
    }
  },

  async getFields({ commit }) {
    try {
      const response = await BoosterService.boosterFields()
      if (response) {
        commit('SET_BOOSTER_FIELDS', response.data)
      }
    } catch (e) {
      showErrorToast(e)
      return e
    }
  },

  async addPoints(_, data) {
    try {
      return await UserService.addPoints(data)
    } catch (e) {
      showErrorToast(e)
      return e
    }
  },

  async loadBoosterPreview({ commit }) {
    try {
      const response = await BoosterService.boostersPreview()
      if (isOk(response)) {
        commit('SET_BOOSTERS_PREVIEW', response.data)
      }
    } catch (e) {
      showErrorToast(e)
      console.error(e)
    }
  },

  async loadBoosters({ commit }, payload = 1) {
    try {
      const page = typeof payload === 'object' ? payload.page || 1 : payload
      const search = typeof payload === 'object' ? payload.search || '' : ''
      const response = await BoosterService.boosters(page, search)
      if (isOk(response)) {
        commit('SET_BOOSTERS_LIST', response.data.data)
        commitPaginationFromMeta(commit, response)
      }
    } catch (e) {
      showErrorToast(e)
      console.error(e)
    }
  },

  async loadInactiveBoosters({ commit }, userId) {
    const response = await BoosterService.inactiveUserBoosters(userId)
    commit('SET_INACTIVE_BOOSTERS', response.data.data)
  },

  async uploadBoosterFile({ commit }, form) {
    try {
      commit('SET_BOOSTER_IMPORT_ERRORS', null)
      commit('SET_BOOSTER_IMPORT_SUCCESS', false)

      const response = await BoosterImporterService.uploadFile(form)

      if (response.status === 200) {
        commit('SET_BOOSTER_IMPORT_SUCCESS', true)
        return true
      } else if (response.status === 422) {
        commit('SET_BOOSTER_IMPORT_ERRORS', response.data)
        return false
      } else {
        return false
      }
    } catch (error) {
      showErrorToast(error)
      commit('SET_BOOSTER_IMPORT_ERRORS', error)
      return false
    }
  },

  async loadBoosterCCSDocuments({ commit }, data) {
    try {
      const response = await BoosterImporterService.getDocuments(data.page)
      commit('SET_BOOSTER_CCS_DOCUMENTS', response.data.data)
      commitPaginationFromMeta(commit, response)
    } catch (err) {
      showErrorToast(err)
      return err
    }
  },

  async loadBooster({ commit }, id) {
    try {
      const response = await BoosterService.booster(id)

      if (response) {
        const payload = response.data || {}
        const boosterData = payload.booster || null

        if (boosterData && typeof boosterData === 'object') {
          boosterData.hashid =
            boosterData.hashid ??
            boosterData.hashId ??
            boosterData.hash_id ??
            payload.hashid ??
            payload.hashId ??
            null

          if (boosterData.active === undefined || boosterData.active === null) {
            boosterData.active = boosterData.is_active ?? boosterData.isActive ?? false
          }
        }

        commit('SET_BOOSTER', boosterData)
        commit('SET_BOOSTER_MESSAGE', payload.message)
      }
    } catch (err) {
      showErrorToast(err)
      return err
    }
  }
}
